import type { ITicket } from '@appTypes/global'

/** Club-owned requests can be edited; inbound requests from other clubs cannot. */
export function canEditTicket(ticket: ITicket): boolean {
  return !ticket.direction || ticket.direction === 'outbound'
}

export function canFinishTicket(
  ticket: ITicket,
  page: 'OpenTickets' | 'TicketsHistory'
): boolean {
  return page === 'OpenTickets' && canEditTicket(ticket) && !ticket.isFinished
}
